/**
 * 管理端表格视图状态辅助
 */

import { renderTableLoading, renderTableError } from "./utils.js";

export async function withTableLoading({
  tbody,
  colSpan,
  page,
  loadingMessage = "加载中...",
  errorMessage,
  onRetry,
  task,
  onError,
}) {
  renderTableLoading(tbody, colSpan, loadingMessage);
  try {
    return await task();
  } catch (error) {
    renderTableError(tbody, colSpan, errorMessage, () => onRetry?.(page));
    onError?.(error);
    return null;
  }
}
